import {map} from 'lodash';
import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router';
import {toast} from 'react-toastify';

import KyError from 'components/Errors/KyError';
import Loading from 'components/Loading';
import useAppContext from 'conf/AppContext';
import {useGet} from 'helpers/KyHooks';
import UserTechStackForm from 'pages/protected/dashboard/techStack/Form';


export default function UserTechStackPage() {
  const appContext = useAppContext();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const {response: techStackOptions, error: techStackOptionsErr} = useGet('api/v1/techStacks/list', {
    cacheResponse: false,
  }, {
    transform: (r) => map(r?.data?.techStacks, (val) => ({
      label: val?.techStackName,
      value: val?.techStackName,
      category: val?.category,
    })),
  });

  useEffect(() => {
    const abortController = new AbortController();
    const loadData = async () => {
      try {
        const rez = await appContext.api.get('api/v1/users/profileWithTechStack', {
          parseJson: true,
        }, abortController);
        setData(rez?.data?.user);
      } catch (err) {
        if (err?.response?.status === 401) {
          localStorage.clear();
          navigate('/');
        }
        setError(err);
      }
    };
    // noinspection JSIgnoredPromiseFromCall
    loadData();

    return () => {
      abortController.abort();
    };

  }, []);
  
  const saveHandler = () => {
    toast.success('Tech stack successfully updated!');
  };
  
  
  let body = <Loading />;
  const allDataLoaded = data && techStackOptions;
  if (allDataLoaded) {
    body = (
      <UserTechStackForm
        user={data}
        techStackOptions={techStackOptions}
        onSave={saveHandler}
      />
    );
  } else if (techStackOptionsErr || error) {
    body = (
      <>
        <KyError kyError={error} />
        <KyError kyError={techStackOptionsErr} />
      </>
    );
  }

  return body;
}
